import React from "react";
import IngressoReclamoController from "../IngressoReclamoController";
import ConsultStateRequest from "../../consult-state-request/components/ConsultStateRequest";
import ConsultStateClaim from "../../consult-state-claim/components/ConsultStateClaim";
import IngressoSolicitud from "../IngressoSolicitud";
import { urlParams, decode_utf8 } from "../../../common/utils/utilsFunc";

const ControllerCompAndRelPublic = ({ props }) => {
  const [initialStateComponent, setInitialStateComponent] = React.useState({
    CTI: "0",
    solicitud: false,
  });
  const [actionParam, setActionParam] = React.useState("ingreso-reclamo");
  const TAB_URL_QUERY_STRING = "accion";

  function handleClickTab(type) {
    let CTI = "";

    switch (type) {
      case "ingreso-reclamo":
        setInitialStateComponent({ CTI: initialStateComponent.CTI, solicitud: false });
        break;
      case "ingreso-solicitud":
        CTI = urlParams.get("cti");
        setInitialStateComponent({ CTI: CTI, solicitud: true });
        break;
      case "seguimento-solicitud":
        setInitialStateComponent({ CTI: initialStateComponent.CTI, solicitud: false });
        break;
      case "seguimento-reclamo":
        setInitialStateComponent({ CTI: initialStateComponent.CTI, solicitud: false });
        break;
    }

    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(TAB_URL_QUERY_STRING, type);
    let newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      "?" +
      searchParams.toString();
    window.history.pushState({ path: newurl }, "", newurl);
    setActionParam(type);
  }

  React.useEffect(() => {
    const param = new URLSearchParams(window.location.search).get(TAB_URL_QUERY_STRING);

    if (param) {
      setActionParam(param);
    }
  }, []);

  return (
    <div className="bg-white">
      <nav className="container-table pl-0 pr-0 pt-0">
        <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
          <li className="nav-item">
            <a
              onClick={() => handleClickTab("ingreso-reclamo")}
              className={`nav-link ${actionParam === "ingreso-reclamo" && "active"}`}
              id="ingresso-reclamo"
              data-toggle="tab"
              href="#ingressoReclamo"
              role="tab"
              aria-controls="ingressoReclamo"
              aria-selected="true"
              data-lineheight="30"
              data-fontsize="18"
            >
              Ingreso de Reclamo
            </a>
          </li>

          <li className="nav-item">
            <a
              onClick={() => handleClickTab("ingreso-solicitud")}
              className={`nav-link ${actionParam === "ingreso-solicitud" && "active"}`}
              id="ingresso-solicitud"
              data-toggle="tab"
              href="#ingressoSolicitud"
              role="tab"
              aria-controls="ingressoSolicitud"
              aria-selected="false"
              data-lineheight="30"
              data-fontsize="18"
            >
              Ingreso de Solicitudes
            </a>
          </li>
          <li className="nav-item">
            <a
              onClick={() => handleClickTab("seguimento-solicitud")}
              className={`nav-link ${actionParam === "seguimento-solicitud" && "active"}`}
              id="seguimento-solicitud"
              data-toggle="tab"
              href="#seguimentoSolicitud"
              role="tab"
              aria-controls="seguimentoSolicitud"
              aria-selected="false"
              data-lineheight="30"
              data-fontsize="18"
            >
              Seguimiento de Solicitudes
            </a>
          </li>
          <li className="nav-item">
            <a
              onClick={() => handleClickTab("seguimento-reclamo")}
              className={`nav-link ${actionParam === "seguimento-reclamo" && "active"}`}
              id="seguimento-reclamo"
              data-toggle="tab"
              href="#seguimentoReclamo"
              role="tab"
              aria-controls="seguimentoReclamo"
              aria-selected="false"
              data-lineheight="30"
              data-fontsize="18"
            >
              Seguimiento de Reclamo
            </a>
          </li>
        </ul>
      </nav>
      <div className="tab-content" id="myTabContent">
        <div
          className={`tab-pane fade ${actionParam === "ingreso-reclamo" && "show active"}`}
          id="ingressoReclamo"
          role="tabpanel"
          aria-labelledby="ingresso-reclamo"
        >
          <IngressoReclamoController
            props={props}
            titleReclamo={decode_utf8(props.titulo_reclamo)}
            codigo_empresa={decode_utf8(props.codigo_empresa)}
            textFetchError={decode_utf8(props.text_fetch_error)}
            url={decode_utf8(props.url_ws_empresa)}
            solicitud={initialStateComponent.solicitud}
          />
        </div>
        <div
          class={`tab-pane fade ${actionParam === "ingreso-solicitud" && "show active"}`}
          id="ingressoSolicitud"
          role="tabpanel"
          aria-labelledby="ingresso-solicitud"
        >
          {initialStateComponent.solicitud && (
            <IngressoSolicitud
              props={props}
              codigo_empresa={decode_utf8(props.codigo_empresa)}
              textFetchError={decode_utf8(props.text_fetch_error)}
              url={decode_utf8(props.url_ws_empresa)}
              CTI={initialStateComponent.CTI}
              solicitud={initialStateComponent.solicitud}
              tituloSolicitud={decode_utf8(props.titulo_ingreso_solicitud)}
              msgVerification={decode_utf8(props.msg_verification_read_ingreso_solicitud)}
              msgCost={decode_utf8(props.msg_cost_ingreso_solicitud)}
            />
          )}
        </div>
        <div
          class={`tab-pane fade ${actionParam === "seguimento-solicitud" && "show active"}`}
          id="seguimentoSolicitud"
          role="tabpanel"
          aria-labelledby="seguimento-solicitud"
        >
          <ConsultStateRequest props={props} />
        </div>
        <div
          class={`tab-pane fade ${actionParam === "seguimento-reclamo" && "show active"}`}
          id="seguimentoReclamo"
          role="tabpanel"
          aria-labelledby="seguimento-reclamo"
        >
          <ConsultStateClaim props={props} />
        </div>
      </div>
    </div>
  );
};

export default ControllerCompAndRelPublic;
